<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 60vw">
      <div class="modal-header">
        <h3>{{ editingRecord ? "Edit" : "Record" }} Immunization</h3>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="saveRecord">
          <div class="form-grid">
            <div class="form-group full-width">
              <label>Vaccine *</label>
              <select v-model="form.vaccine" required class="form-control">
                <option value="">Select</option>
                <option value="BCG">BCG</option>
                <option value="OPV0">OPV 0</option>
                <option value="OPV1">OPV 1</option>
                <option value="OPV2">OPV 2</option>
                <option value="OPV3">OPV 3</option>
                <option value="Pentavalent1">Pentavalent 1</option>
                <option value="Pentavalent2">Pentavalent 2</option>
                <option value="Pentavalent3">Pentavalent 3</option>
                <option value="PCV1">PCV 1</option>
                <option value="PCV2">PCV 2</option>
                <option value="PCV3">PCV 3</option>
                <option value="Rotavirus1">Rotavirus 1</option>
                <option value="Rotavirus2">Rotavirus 2</option>
                <option value="IPV">IPV</option>
                <option value="Measles-Rubella1">Measles-Rubella 1</option>
                <option value="Measles-Rubella2">Measles-Rubella 2</option>
                <option value="Yellow Fever">Yellow Fever</option>
                <option value="Vitamin A">Vitamin A</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div class="form-group">
              <label>Dose</label>
              <input type="text" v-model="form.dose" placeholder="e.g. 1st dose" class="form-control" />
            </div>
            <div class="form-group">
              <label>Date Given *</label>
              <input type="date" v-model="form.date_given" required class="form-control" />
            </div>
            <div class="form-group">
              <label>Next Due Date</label>
              <input type="date" v-model="form.next_due_date" class="form-control" />
            </div>
            <div class="form-group">
              <label>Status</label>
              <select v-model="form.status" class="form-control">
                <option value="given">Given</option>
                <option value="missed">Missed</option>
                <option value="deferred">Deferred</option>
              </select>
            </div>
            <div class="form-group">
              <label>Batch Number</label>
              <input type="text" v-model="form.batch_number" class="form-control" />
            </div>
            <div class="form-group">
              <label>Site</label>
              <input type="text" v-model="form.site" placeholder="e.g. Left thigh" class="form-control" />
            </div>
            <div class="form-group">
              <label>Given By</label>
              <input type="text" v-model="form.given_by" class="form-control" />
            </div>
            <div class="form-group full-width">
              <label>Side Effects Noted</label>
              <textarea v-model="form.side_effects_noted" class="form-control" rows="2"></textarea>
            </div>
            <div class="form-group full-width">
              <label>Remarks</label>
              <textarea v-model="form.remarks" class="form-control" rows="2"></textarea>
            </div>
          </div>
          <div class="modal-actions">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              {{ saving ? "Saving..." : (editingRecord ? "Update" : "Save") + " Immunization" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../../api/apiIndex";

export default {
  name: "ImmunizationModal",
  props: {
    visitId: { type: [Number, String], default: null },
    editRecord: { type: Object, default: null },
  },
  data() {
    return {
      saving: false,
      editingRecord: null,
      form: this.emptyForm(),
    };
  },
  created() {
    if (this.editRecord) {
      this.editingRecord = this.editRecord;
      this.form = {
        ...this.emptyForm(),
        ...this.editRecord,
        date_given: this.editRecord.date_given ? this.editRecord.date_given.substring(0, 10) : "",
        next_due_date: this.editRecord.next_due_date ? this.editRecord.next_due_date.substring(0, 10) : "",
      };
    }
  },
  methods: {
    emptyForm() {
      const today = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return {
        vaccine: "",
        dose: "",
        date_given: `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`,
        next_due_date: "",
        status: "given",
        batch_number: "",
        site: "",
        given_by: "",
        side_effects_noted: "",
        remarks: "",
      };
    },
    closeModal() {
      this.$emit("close");
    },
    async saveRecord() {
      this.saving = true;
      try {
        const payload = { ...this.form, visit_id: this.visitId };
        let response;
        if (this.editingRecord) {
          response = await generalApiRequest(`cwc_immunizations/${this.editingRecord.id}`, "PUT", payload, 1);
        } else {
          response = await generalApiRequest("cwc_immunizations", "POST", payload, 1);
        }
        if (response.success) {
          this.$emit("saved", response.data);
          this.closeModal();
        } else {
          alert(response.message || "Failed to save immunization");
        }
      } catch (error) {
        console.error("Error saving immunization:", error);
        alert("An error occurred while saving the immunization");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.mmodal-content { background: white; border-radius: 10px; max-height: 90vh; overflow-y: auto; display: flex; flex-direction: column; }
.modal-header { padding: 20px; background: linear-gradient(135deg, #ed8936 0%, #c05621 100%); color: white; display: flex; justify-content: space-between; align-items: center; }
.modal-header h3 { margin: 0; font-size: 20px; }
.close { background: rgb(233, 22, 22); border: 1px solid rgb(182, 178, 178); font-size: 1.5rem; color: white; line-height: 1; cursor: pointer; }
.modal-body { padding: 30px; overflow-y: auto; flex-grow: 1; }
.form-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; margin-bottom: 20px; }
.form-group { margin-bottom: 15px; }
.form-group.full-width { grid-column: 1 / -1; }
.form-group label { display: block; margin-bottom: 5px; font-weight: 600; color: #495057; }
.form-control { width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 14px; }
.modal-actions { display: flex; justify-content: flex-end; gap: 15px; }
.btn { padding: 10px 25px; border: none; border-radius: 5px; cursor: pointer; font-weight: 600; }
.btn-secondary { background: #6c757d; color: white; }
.btn-secondary:hover { background: #5a6268; }
.btn-primary { background: #c05621; color: white; }
.btn-primary:hover { background: #9c4221; }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
@media (max-width: 768px) { .form-grid { grid-template-columns: 1fr; } }
</style>
